<div class="site-footer">
	<div class="footer-wrapper">
		<div class="grid-info wrap">
			<div class="footer-content">
				<!-- note: from post-sprint 8 merge
				<div *ngIf="(isCorporate$|async)===true" class="box-info first logo">
					<a (click)="TAP_handleItemClick()" tabindex="0" aria-label='Go to home page' role="button">
						<app-svg class="footer-logo" svg="sprite.svg#logo--tap_corporate" [alt]="'TAP Air Portugal logo'"></app-svg>
					</a>
				</div>
				-->
				<!-- note: from post-sprint 8 merge (replace the div below)
				<div class="box-info first"  [ngClass]="{'first': (isCorporate$|async)!==true, 'second': (isCorporate$|async)===true}">
				-->
				<div class="box-info first">
					<div class="title">
						Siga-nos
					</div>
					<div class="footer-information js-not-accordion">
						<ul class="label-icn">
							<li>
								<a (click)="openNewTab('http://www.facebook.com/TAPAirPortugal')" target="_blank"
									title="Este link abre uma nova janela." class="icn first">
									<img src="assets/header-footer/images/Facebook_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
							<li>
								<a href="https://www.instagram.com/tapairportugal/" target="_blank"
									title="Este link abre uma nova janela." class="icn">
									<img src="assets/header-footer/images/Instagram_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
							<li>
								<a href="https://www.linkedin.com/company/tap-air-portugal" target="_blank"
									title="Este link abre uma nova janela." class="icn">
									<img src="assets/header-footer/images/Linkedin_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
							<li>
								<a href="https://www.pinterest.pt/tapairportugal" target="_blank"
									title="Este link abre uma nova janela." class="icn">
									<img src="assets/header-footer/images/Pinterest_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
							<li>
								<a href="https://twitter.com/tapairportugal" target="_blank"
									title="Este link abre uma nova janela." class="icn">
									<img src="assets/header-footer/images/Twitter_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
							<li>
								<a href="https://www.youtube.com/user/tap" target="_blank"
									title="Este link abre uma nova janela." class="icn">
									<img src="assets/header-footer/images/Youtube_Footer.svg" class="img" alt="" />
									<span class="mod-hidden">Abre numa nova janela</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="box-info second">
					<div class="extra-info">
						<div class="title">TAP App</div>
						<div class="area-app-wrapper">
							<a href="https://play.google.com/store/apps/details?id=com.megasis.android&amp;feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5tZWdhc2lzLmFuZHJvaWQiXQ.."
								target="_blank" aria-label="Downloads TAP airlines's Android app, opens a window">
								<img src="assets/header-footer/images/stamp-google-play.svg" alt="" />
							</a>
							<a href="https://itunes.apple.com/pt/app/tap-portugal/id440497198?mt=8" target="_blank"
								aria-label="Downloads TAP airlines's IOS app, opens a window">
								<img src="assets/header-footer/images/stamp-app-store.svg" alt="" />
							</a>
						</div>
					</div>
				</div>
				<div class="box-info last">
					<div class="extra-info">
						<div class="title">App Portugal Stopover</div>
						<div class="area-app-wrapper">
							<a href="https://play.google.com/store/apps/details?id=pt.tap.stopover" target="_blank"
								title="Este link abre uma nova janela.">
								<img src="assets/header-footer/images/stamp-google-play.svg" alt="" />
							</a>
							<a href="https://itunes.apple.com/pt/app/tap-stopover/id1118371166" target="_blank"
								title="Este link abre uma nova janela.">
								<img src="assets/header-footer/images/stamp-app-store.svg" alt="" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>